import { initializeChakraComponent } from 'Shared/chakra-initialize';
import Navigation from './navigation';

initializeChakraComponent('CommunityNav', Navigation);
